// Set config defaults when creating the instance

import axios from 'axios';
import { apiUrl } from './constants';
import { notification } from 'antd';

let baseURL = apiUrl();

export const http = axios.create({
  baseURL: baseURL,
  timeout: 60000,
});

// Add a response interceptor
http.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response.status === 403) {
    }

    if (error.response.status === 422) {
      notification.error({ message: error.response.data.message });
      window.location.href = '/';
    }

    // Do something with response error
    return Promise.reject(error);
  },
);

export const setAuthorizationHeader = (token = null) => {
  if (token) {
    http.defaults.headers.common.Authorization = `Token ${token}`;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
};
